import React from 'react';
import classnames from 'classnames';

import styles from './TextButton.scss';

export default function TextButton(props) {
    const {className, ...restProps} = props;
    return (
        <button
            className={classnames(
                styles.button,
                className,
            )}
            {...restProps}
        />
    );
}



// WEBPACK FOOTER //
// ./src/components/controls/buttons/TextButton.jsx